import type { ReactNode } from 'react';

interface AppShellProps {
  children: ReactNode;
}

const navigation = ['Overview', 'Activities', 'Roster', 'Transport', 'Tasks'];

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>
      <aside className="sidebar" aria-label="Primary navigation">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">
            LD
          </span>
          <span>
            <strong>Liwanag at Dunong</strong>
            <small>Operations portal</small>
          </span>
        </div>
        <nav>
          <ul>
            {navigation.map((item, index) => (
              <li key={item}>
                <a
                  className={index === 0 ? 'active' : undefined}
                  href={index === 0 ? '#overview' : `#${item.toLowerCase()}`}
                >
                  {item}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div className="sidebar-note">
          <strong>Synthetic environment</strong>
          <span>No real-person data allowed</span>
        </div>
      </aside>
      <div className="workspace">
        <header className="topbar">
          <div>
            <span className="environment-badge">Development · synthetic only</span>
          </div>
          <div className="account-placeholder" aria-label="Current temporary operator">
            <span aria-hidden="true">OP</span>
            <div>
              <strong>Operations placeholder</strong>
              <small>Temporary role code</small>
            </div>
          </div>
        </header>
        <main id="main-content">{children}</main>
      </div>
    </div>
  );
}
